import { css } from '~/lib/bn-lit-element';

export const levelChartStyles = css`
:host {
  display: block;
  position: relative;
  width: 100%;
  min-width: 200px;
  height: auto;
}
.chart {
  background-color: var(--surface, white);
  color: var(--on-surface);
  height: 250px;
  min-height: 100px;
  margin-bottom: 10px;
}
.chart .background {
  fill: var(--surface);
}
.chart .forecast-region {
  fill: none;
}
.chart .refill-tick {
  stroke: var(--gray-60);
  stroke-width: 2px;
  fill: none;
}
.chart .raw-point {
  stroke: none;
  fill-opacity: 0;
  transition: fill-opacity 300ms;
}
.chart .raw-point.prospect {
  fill-opacity: 1;
}
.chart.show-raw .raw-point {
  fill-opacity: 1;
  transition: fill-opacity 300ms;
}
.chart .raw-point.manual {
  fill-opacity: 1;
  stroke: var(--gray-70);
  stroke-width: 1px;
}
.chart .raw-point.outlier {
  fill: var(--gray-40);
}
.chart .fill-line {
  fill: none;
  stroke-width: 6px;
  stroke-linejoin: round;
}
.chart .fill-area {
  stroke: none;
}
.chart .past-estimates.fill-line {
  transition: stroke-opacity 300ms;
}
.chart.show-raw .past-estimates.fill-line {
  stroke-opacity: 0.4;
  transition: stroke-opacity 300ms;
}
.chart .past-estimates.fill-area {
  fill: var(--gray-40);
}
.chart .initial-estimates {
  stroke-width: 1px;
  stroke: black;
}
.chart .forecast.fill-line {
  stroke: var(--blue-60);
  stroke-linecap: round;
  stroke-dasharray: 8px 8px;
}
.chart .forecast.fill-area {
  fill: var(--blue-60);
}
.chart .tooltip {
  color: var(--black-base);
  position: absolute;
  right: 0;
  left:  0;
  padding: 3px 10px;
  text-align: center;
  font-family: var(--content-font, sans-serif);
}
.chart .tooltip .magnitude {
  font-weight: bolder;
  font-size: 15px;
}
.chart .tooltip .raw {
  display: none;
  margin-left: 15px;
  color: var(--gray-70);
}
.chart.show-raw .tooltip .raw {
  display: initial;
}
.chart #tooltip {
  top: 0;
  font-size: 13px;
  line-height: 13px;
}
.chart #tooltip2 {
  color: var(--gray-70);
  top: 14px;
  font-size: 11px;
}
.chart .axis text {
  font-size: 10px;
}
.chart .focus {
  pointer-events: none;
}
.chart .focusLine {
  fill: none;
  stroke: var(--gray-70);
  stroke-width: 2px;
  stroke-dasharray: 0 6px;
  stroke-linecap: round;
}
.chart .focusCircle {
  fill: none;
  stroke: var(--gray-70);
  stroke-width: 2px;
  opacity: 0.8;
}
.chart .selectionCircle {
  fill: none;
  stroke: var(--blue-60);
  stroke-width: 2px;
  opacity: 0.8;
}
.chart .selectionRect {
  fill: var(--blue-30);
  opacity: 0.5;
}
.chart .manual-feed-mask {
  fill: var(--blue-60);
  opacity: 0.9;
}
.chart .axis path,
.chart .axis line {
  fill: none;
  stroke:  var(--gray-40);
  shape-rendering: crispEdges;
}
.chart .axis.percent path {
  stroke: none;
}
.chart .axis.percent text {
  color: var(--gray-50);
}
.chart .axis.no-ticks line,
.chart .axis.no-ticks path {
  stroke: none;
}
.chart text {
  font-size: .8em;
}
.chart .label.now line {
  stroke-width: 2px;
  stroke: var(--gray-70);
}
.chart .label.now text {
  color: var(--gray-70);
}
.chart .overlay {
  display: none;
  fill-opacity: 0.8;
}
.chart.no-data .overlay, .chart.loading .overlay {
  fill: var(--gray-20);
  display: initial;
}

.chart .loading-message {
  display: none;
  font-size: 1.4em;
  fill: var(--gray-50);
}

.chart.loading .loading-message {
  display: initial;
}

.chart .no-data-message {
  display: none;
  font-size: 1.4em;
  fill: var(--gray-50);
}

.chart.no-data .no-data-message {
  display: initial;
}
`;

export default levelChartStyles.toString();
